import { useEffect, useState } from "react";
import { cn, getFormattedTime } from "@util/helpers";

export type UpdatedTimerops = {
  className?: string;
  updated: string;
  dateFormat?: string;
};

/**
 * CreateTime
 * Description: The publish time of the article
 */
const UpdatedTime = ({
  className,
  updated,
  dateFormat,
}: UpdatedTimerops): React.ReactElement => {
  const [publishedDate, setPublishedDate] = useState("");

  useEffect(() => {
    setPublishedDate(getFormattedTime(updated, dateFormat));
  }, [updated, dateFormat]);

  return (
    <div
      className={cn(
        "typo-timestamp truncate uppercase text-gray-550",
        className
      )}
      data-testid="created-time-component"
    >
      {publishedDate}
    </div>
  );
};

export default UpdatedTime;
